import { Label, Panel, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutMultiLoadTenderResults } from "./autogen/AutogenLayoutMultiLoadTenderResults";
import { ModelRow } from "@mcleod/core";

export class MultiLoadTenderResults extends AutogenLayoutMultiLoadTenderResults {
    async autoSendLoadTenders(multiRateConProps: any[], payee_id: string) {
        await this.mainDataSource.search({movements: multiRateConProps, payee_id, is_auto: true});
    }

    tableMultiSendLoadTenderOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const imageDisqualified = tableRow.findComponentById("imageDisqualified");
        const imageSucess = tableRow.findComponentById("imageSucess");
        if (imageDisqualified != null && imageSucess != null) {
            if (modelRow.get("tenderSent")) {
                imageDisqualified.visible = false;
                imageSucess.visible = true;
            }
            else {
                imageSucess.visible = false;
                imageDisqualified.visible = true;
                imageDisqualified.tooltipDynamicContent = () => {
                    const panel = new Panel({ padding: 0, margin: 0 });
                    panel.add(new Label({ text: "Errors", fontSize: "xlarge", fontBold: true }));
                    panel.add(new Label({ text: modelRow.get("text") }));
                    return panel;
                }
            }
        }
    }
}
